// extracted by mini-css-extract-plugin
module.exports = {"form":"EditForm_form__2-ev_","form__header":"EditForm_form__header__9P9u4","form__content":"EditForm_form__content__3UNOZ","form__img":"EditForm_form__img__mal8F"};